import React from 'react';
import DetallePedido from './DetallePedido';
import firebase from './../Firestore'
import config from 'react-global-configuration';
import store from '../../store';

import TimeAgo from 'react-timeago'
import espanolStrings from 'react-timeago/lib/language-strings/es'
import buildFormatter from 'react-timeago/lib/formatters/buildFormatter'


const formatter = buildFormatter(espanolStrings)

class EstadoPedido extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      pedido: [],
      nroPedidoMasReciente: store.getState().nroPedidoMasReciente
     };

     store.subscribe(() => {
       this.setState({
         nroPedidoMasReciente: store.getState().nroPedidoMasReciente
       })
     });

  }

  levantarDatos(uid, pedidoId=null){

      let currentComponent = this;
      //var pedidoId;
      let db = firebase.firestore()
      // Buscar el pedido mas reciente pendiete

      if (pedidoId) {
        this.buscarPorPedidoId(db, pedidoId, currentComponent)
      } else {
        this.buscarPorUid(db, uid, currentComponent)
      }



  }

buscarPorPedidoId(db, pedidoId, currentComponent){
  var docRef = db.collection("pedido").doc(pedidoId);

  docRef.onSnapshot(function(doc) {
      if (doc.exists) {
          //console.log("Document data:", doc.data());
          let pedido = [];
          pedido[0] = {
            pedidoId: doc.id,
            estado: doc.data().estado,
            fecha: doc.data().fecha,
            total: doc.data().total,
            clienteDireccion: doc.data().clienteDireccion,
            clienteNombre: doc.data().clienteNombre,
            clienteTelefono: doc.data().clienteTelefono,
            formaEntrega: doc.data().formaEntrega,
            momentoEntrega: doc.data().momentoEntrega,
            usuarioProgramarEntrega: doc.data().usuarioProgramarEntrega,
            usuarioAclaraciones: doc.data().usuarioAclaraciones,
            horaEntrega: doc.data().horaEntrega,
          }

          currentComponent.setState({pedido: pedido})

      } else {
          // doc.data() will be undefined in this case
          console.log("No such document!");
      }
  });
}

buscarPorUid(db, uid, currentComponent){
  db.collection("pedido").where("uid", "==", uid).orderBy("fecha", "desc").limit(1)
    .onSnapshot(function(querySnapshot) {
      let pedido = [];
      querySnapshot.forEach(function(doc) {
          pedido.push({
            pedidoId: doc.id,
            estado: doc.data().estado,
            fecha: doc.data().fecha,
            total: doc.data().total,
            clienteDireccion: doc.data().clienteDireccion,
            clienteNombre: doc.data().clienteNombre,
            clienteTelefono: doc.data().clienteTelefono,
            formaEntrega: doc.data().formaEntrega,
            momentoEntrega: doc.data().momentoEntrega,
            usuarioProgramarEntrega: doc.data().usuarioProgramarEntrega,
            usuarioAclaraciones: doc.data().usuarioAclaraciones,
            horaEntrega: doc.data().horaEntrega
          });
      currentComponent.setState({pedido: pedido})
        });
      }
    )
}


componentDidUpdate(){
  //console.log("didUpdate nro pedido", this.state.nroPedidoMasReciente)
}


  componentWillMount(){
    //console.log("willMount nro pedido", this.state.nroPedidoMasReciente)
    this.levantarDatos(this.props.uid, this.state.nroPedidoMasReciente)
  }

render() {

      if(this.state.pedido.length === 0) return ""

      let claseEstadoActual = "badge badge-primary border mx-2"
      let claseEstadoInactiva = "badge badge-light mx-2"

      let horaEntrega = this.state.pedido[0].horaEntrega ? " | Horario aprox.: "+this.state.pedido[0].horaEntrega.substr(-8, 5)+" hs." : " | En minutos se actualizará en que horario.";
      let celu = this.state.pedido[0].clienteTelefono.slice(-15, -8).length > 0 ? this.state.pedido[0].clienteTelefono.slice(-15, -8) +'-' : '';
      celu = celu + this.state.pedido[0].clienteTelefono.slice(-8, -4) +"-"+ this.state.pedido[0].clienteTelefono.slice(-4);
      
    return (
      <div className="mx-2">
        <h2>Estado de su pedido</h2>
        <p>{ config.get('tienda').nombre } le agradece por su pedido (Nro. <strong>{this.state.pedido[0].pedidoId}</strong>) realizado <TimeAgo date={this.state.pedido[0].fecha.toDate()} formatter={formatter} /></p>
        <p>Se actualizara el estado de su pedido en tiempo real.</p>
        <p>Estado del pedido: <span className={claseEstadoActual}>{this.state.pedido[0].estado}</span>

        <div>
          <span className={this.state.pedido[0].estado === "ingresado"? claseEstadoActual : claseEstadoInactiva}>ingresado</span>
          <i className="fas fa-angle-double-right"></i>
          <span className={this.state.pedido[0].estado === "elaboracion"? claseEstadoActual : claseEstadoInactiva}>en elaboración</span>
          <i className="fas fa-angle-double-right"></i>
          {this.state.pedido[0].formaEntrega === "Delivery" ? (
            <span className={this.state.pedido[0].estado === "terminado"? claseEstadoActual : claseEstadoInactiva}>en camino</span>
          ) : (
            <span className={this.state.pedido[0].estado === "terminado"? claseEstadoActual : claseEstadoInactiva}>listo para retirar por el local</span>
          )}
          <i className="fas fa-angle-double-right"></i>
          <span className={this.state.pedido[0].estado === "entregado"? claseEstadoActual : claseEstadoInactiva}>entregado</span>
        </div>

        </p>



        <p>Cliente: {this.state.pedido[0].clienteNombre} | Tel. {celu}</p>

          {this.state.pedido[0].formaEntrega === "Delivery" ? (
            <p>Delivery a <strong>{this.state.pedido[0].clienteDireccion}</strong>{horaEntrega}</p>
          ) : (
            <p>Retira por nuestro local en { config.get('tienda').direccion }{horaEntrega} </p>
          )}


          {this.state.pedido[0].momentoEntrega === "Inmediata" ? (
            <p>Entrega lo antes posible.</p>
          ) : (
            <p>El cliente solicitó programar la entrega para: <span>{this.state.pedido[0].usuarioProgramarEntrega}</span></p>
          )}

          {this.state.pedido[0].usuarioAclaraciones.length > 0 &&
            <p>
              <strong>Aclaraciones</strong>: {this.state.pedido[0].usuarioAclaraciones}.
            </p>
          }



        <DetallePedido uid={this.props.uid} pedidoId={this.state.pedido[0].pedidoId} productoDetalle={this.props.productoDetalle} cat={this.props.cat} adicionalDetalle={this.props.adicionalDetalle} />
      </div>
    )
  }

}
export default EstadoPedido
